import config from "../config";

export const proxyDownload = async (url,name) =>{
    const response = await fetch(`${config.BASE_URL}proxy-download`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ url, name: name || "download" }),
      });


      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || "Failed to download file.");
      }

      const disposition = response.headers.get("content-disposition") || "";
      let filename = name

      const filenameMatch = disposition.match(/filename="?([^"]+)"?/);
      if (filenameMatch) {
        filename = filenameMatch[1];
      }

      const blob = await response.blob();

      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
}
